import { UserMenu } from '../Auth';

export function Header() {
  return (
    <header className="bg-gradient-honne shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center gap-4">
            {/* Honne Logo */}
            <div className="flex items-center">
              <img 
                src="/logo-honne.png" 
                alt="Honne - Delivering True Value" 
                className="h-12 w-auto"
              />
            </div>
            <div className="h-8 w-px bg-white/20" />
            <div>
              <h1 className="text-lg font-semibold text-white">
                Cloud Cost Optimization
              </h1>
              <p className="text-xs text-accent-400 font-medium">
                Assessment Express 30 Min
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            {/* User Menu con fondo blanco para contraste */}
            <div className="bg-white rounded-lg">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
